const APP_HOSTNAME = 'app.signnow.com';
export const APP_BASE_LINK = `https://${APP_HOSTNAME}`;

export const SELF_SIGN_DISPATCH_LINK = 'https://signnow.com/dispatch';
